import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter, Link } from 'react-router-dom';

import { routes } from '../../constants';
import {
	fetchProductBySlug,
	compareProduct,
	removeCompareProduct,
	goToPreviousItem,
	goToNextItem,
	fetchProductsByCategory,
} from '../../redux/product/productActions';
import { contactForProduct } from '../../redux/contact/contactActions';
import { fetchCategories } from '../../redux/content/contentActions';
import { changeHead } from '../../redux/head/headActions';

import pageConfig from '../../config/page.config';
import { breadcrumbConfig } from '../../config/breadcrumb.config';
import { ABreadCrumb, AButton } from '../../components/atoms';
import { MLoader, MPagination } from '../../components/molecules';
import {
	OProductDetail,
	OProjectsLoadMore,
	OProductsLoadMore,
	OVideoPlayerPopUp,
} from '../../components/organisme';
import store from '../../redux/store/store';

const mapStateToProps = state => ({
	language: state.head.language,
	product: state.product.selected,
	previousButtonLocked: state.product.previousButtonLocked,
	nextButtonLocked: state.product.nextButtonLocked,
	categories: state.content.category,
	isFetching: state.product.isFetching,
});

class ProductDetailPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			product: undefined,
			showCompare: false,
			isCompareSet: false,
			isFetching: true,
			showVideo: false,
		};
	}
	componentDidMount() {
		this.bindHandles();
		const crumbs = this.props.match.url.split('/').filter(item => item !== '');

		this.props.fetchProductBySlug(this.props.match.params.slug);
		this.props.fetchProductsByCategory(this.props.match.params.category);
		this.props.fetchCategories(crumbs[0]);
	}

	componentWillReceiveProps(props) {
		this.setState({
			product: get(props, 'product', []),
			isFetching: get(props, 'isFetching', false),
		});

		// Update SEO title & description
		if (props.product) {
			const seoTitle = props.product.seoTitle || this.props.intl.formatMessage({ id: pageConfig.productDetail.title });
    		const seoDescription = props.product.seoDescription || this.props.intl.formatMessage({ id: pageConfig.productDetail.description });
			this.props.changeHead({
			id: pageConfig.productDetail.id,
				title: seoTitle,
				description: seoDescription,
				showSocialMedia: true,
			});
		}

		if (this.props.match !== props.match) {
			this.props.fetchProductBySlug(props.match.params.slug);
		}

		this.checkIfUserIsComparingProduct(props.product);
	}

	bindHandles() {
		this.handleCompare = this.handleCompare.bind(this);
		this.handleContact = this.handleContact.bind(this);
		this.toggleVideo = this.toggleVideo.bind(this);
	}

	handleCompare(value) {
		this.setState({ showCompare: value.target.checked || this.state.isCompareSet });

		if (value.target.checked) {
			this.props.compareProduct(this.state.product);
			return;
		}

		this.props.removeCompareProduct(this.state.product);
	}
	handleContact() {
		const type = this.props.match.url.split('/').filter(item => item !== '')[0].toUpperCase();

		this.props.contactForProduct(this.state.product);
		this.props.history.push(routes[type].CONTACT);
	}

	toggleVideo() {
		this.setState(prev => ({ showVideo: !prev.showVideo }));
	}

	checkIfUserIsComparingProduct(product) {
		const compareStore = store.getState().product.compare;

		this.setState({
			showCompare: get(compareStore, 'primary.uuid', null) === product.uuid ||
				get(compareStore, 'secondary.uuid', null) === product.uuid,
		});
	}

	render() {
		const url = this.props.match.url.split('/').filter(item => item !== '');
		const translatedUrl = url.slice(0, url.length - 2).map(crumb => breadcrumbConfig[crumb][this.props.language]);
		const category = url.slice(url.length - 2).pop() === 'rent' ? { name: breadcrumbConfig.rent[this.props.language] } :
			this.props.categories.find(cat => cat.slug === url[url.length - 2]);
		let content = <MLoader className="article--loader" />;
		let compareButton;
		let relatedProducts;
		let projects;
		let video;

		translatedUrl.push(get(category, 'name', ''));

		if (this.state.showCompare) {
			const compareUrl = `${this.props.match.url}${routes.COMPARE}`;

			compareButton = (
				<div className="article--compare-button">
					<Link to={compareUrl} href={compareUrl}>
						<AButton value="PRODUCT_DETAIL.COMPARE_BUTTON" />
					</Link>
				</div>
			);
		}

		if (!this.state.isFetching) {
			content = (
				<article className="section-xx layout-body--fill">
					<OProductDetail
						title={get(this.state.product, 'name', '')}
						featuredImage={get(this.state.product, 'featuredImage.url', '')}
						description={get(this.state.product, 'description', '')}
						price={get(this.state.product, 'price', '')}
						webshop={get(this.state.product, 'webshop', '')}
						items={get(this.state.product, 'productInfo', [])}
						documents={get(this.state.product, 'documents', undefined)}
						atex={get(this.state.product, 'atexes', [])}
						showVideo={get(this.state.product, 'videoLink', false)}
						images={get(this.state.product, 'images', [])}
						onCompare={this.handleCompare}
						onContact={this.handleContact}
						isCompared={this.state.showCompare}
						onVideoClick={this.toggleVideo}
					/>
				</article>
			);
		}

		if (get(this.state, 'product.relatedProduct', false) && this.state.product.relatedProduct.length) {
			relatedProducts = (
				<OProductsLoadMore
					title="PRODUCT_DETAIL.SIMILAR_PRODUCTS"
					buttonValue="PRODUCT_DETAIL.LOAD_MORE_PRODUCTS"
					className="section-xx layout-body"
					items={this.state.product.relatedProduct}
					href={this.props.match.url.replace(`/${get(this.state, 'product.slug', '')}`, '')}
				/>
			);
		}

		if (get(this.state, 'product.projects', false) && this.state.product.projects.length) {
			projects = (
				<OProjectsLoadMore
					title="PRODUCT_DETAIL.USED_IN_PROJECT"
					buttonValue="PRODUCT_DETAIL.LOAD_MORE_PROJECTS"
					className="section-xx layout-body"
					items={this.state.product.projects}
				/>
			);
		}

		if (this.state.showVideo) {
			video = (
				<div className="a-section--overlay">
					<OVideoPlayerPopUp
						url={get(this.state.product, 'videoLink', '')}
						onClose={this.toggleVideo}
					/>
				</div>
			);
		}

		return [
			<section className="section--breadcrumb section--product-detail">
				<article className="article--breadcrumb article--breadcrumb-actions">
					<ABreadCrumb
						currentPage={get(this.state.product, 'name', '')}
						parents={translatedUrl}
						mappedUrl={url.slice(0, -1)}
					/>
					<MPagination
						nextLabel="PRODUCT_DETAIL.PAGINATION.NEXT"
						backLabel="PRODUCT_DETAIL.PAGINATION.BACK"
						previousButtonLocked={this.props.previousButtonLocked}
						nextButtonLocked={this.props.nextButtonLocked}
						onBack={this.props.goToPreviousItem}
						onNext={this.props.goToNextItem}
					/>
				</article>
				{compareButton}
				{content}
				{relatedProducts}
				{projects}
			</section >,
			video,
		];
	}
}

ProductDetailPage.propTypes = {
	changeHead: PropTypes.func.isRequired,
	fetchProductBySlug: PropTypes.func.isRequired,
	fetchCategories: PropTypes.func.isRequired,
	compareProduct: PropTypes.func.isRequired,
	removeCompareProduct: PropTypes.func.isRequired,
	contactForProduct: PropTypes.func.isRequired,
	goToPreviousItem: PropTypes.func.isRequired,
	goToNextItem: PropTypes.func.isRequired,
	fetchProductsByCategory: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	changeHead,
	fetchProductBySlug,
	fetchCategories,
	compareProduct,
	removeCompareProduct,
	contactForProduct,
	goToPreviousItem,
	goToNextItem,
	fetchProductsByCategory,
})(injectIntl(ProductDetailPage)));



// WEBPACK FOOTER //
// ./src/pages/producten/product-detail.js